export enum ReturnType {
  /**
   * scalar
   */
  Scalar = 0,
  /**
   * observable
   */
  Observable = 10,
  /**
   * promise
   */
  Promise = 20
}
